import React from 'react';
import { Button, FormCheck as Checkbox, Row, Col } from 'react-bootstrap';

//import filterFactory from 'react-bootstrap-table2-filter';

import Table from '../Table';
import { IPermission, IPermissionFilter } from '../../lib/types/types';

import { graphQLPost } from '../../lib/utilities'
import { Administration } from '../../lib/dataAccess/DataAccess';
import Loading from '../visuals/Loading';
import ErrorMessage from '../visuals/ErrorMessage';
import { PermissionTypes } from '../../lib/utilities';

import { ColumnDescription } from 'react-bootstrap-table-next';
import { FaRegIdBadge } from 'react-icons/fa';

interface Props {
    roleId: number,
    onSaveComplete?: {(permissions: IPermission[]) : void}
}
interface State { 
    isSaving: boolean,
    selectedIndex: number,
    selectedPermissionType: number,
    filterObjects: { displayName: string, fieldName: string, data: any }[],
    selectedIds: number[],
    error: string | null
}

export default class CreateRolePermission extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.fetchData = this.fetchData.bind(this);
        this.changeId = this.changeId.bind(this);
        this.changeIndex = this.changeIndex.bind(this);
        this.changePermissionType = this.changePermissionType.bind(this);
        this.createRolePermission = this.createRolePermission.bind(this);
        
        this.state = {
            isSaving: false,
            selectedIndex: -1,
            selectedPermissionType: -1,
            filterObjects: [],
            selectedIds: [],
            error: null
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const permissionFilters = await Administration.getFilters();

        const queryResults = await Promise.all(permissionFilters.map((filter) => graphQLPost(`{${filter.query}}`)))

        const filterObjects = 
            queryResults.filter((r => r !== undefined))
            .map((r,i) => {
                const permissionFilter = permissionFilters[i];

                return { 
                    displayName: permissionFilter.displayName,
                    fieldName: permissionFilter.fieldName,
                    data: r[permissionFilters[i].queryName].map((e: any, index: number) => ({...e, checked: false, index}))
                };
            });

        this.setState({filterObjects});
    }

    async createRolePermission() {
        this.setState({isSaving: true}, async () => {
            const { roleId } = this.props;
            const { selectedIds, selectedIndex, selectedPermissionType } = this.state;
            const fieldName = this.state.filterObjects[selectedIndex].fieldName;

            const permissions: IPermission[] = selectedIds.map(fieldValue => ({
                id: -1,
                fieldName,
                fieldValue,
                permissionTypeId: selectedPermissionType
            }));

            try {
                const resp = await Administration.PermissionRole.addPermissions(roleId, permissions);

                this.setState({isSaving: false}, ()  => { 
                    if(this.props.onSaveComplete !== undefined) {
                        this.props.onSaveComplete(resp);
                    }
                });
            }
            catch(error) {
                this.setState({isSaving: false, error});
            }
        });
    }
    

    changePermissionType(e: React.ChangeEvent<HTMLSelectElement>) {

        const selectedPermissionType = parseInt(e.target.value);

        this.setState({selectedPermissionType});
    }

    changeIndex(e: React.ChangeEvent<HTMLSelectElement>) {
        const { selectedIndex } = this.state;
        const newIndex = parseInt(e.target.value);

        if(newIndex !== selectedIndex) {
            // Resets 'selectedIds' and sets all of the '<object>.checked = false' in the corresponding data array
            this.setState(({filterObjects}) => ({
                selectedIndex: newIndex, 
                selectedIds: [],
                filterObjects: [
                    ...filterObjects.slice(0, newIndex),
                    {
                        ...filterObjects[newIndex],
                        // Alternativly store a 'restore'-version of the data arrays 
                        // in order to easily reset the 'checked'-fields
                        data: filterObjects[newIndex].data.map((e: any) => ({...e, checked: false}))
                    },
                    ...filterObjects.slice(newIndex + 1)
                ]
            }));
        }
    }

    changeId(row: any, index: number) {
        const { filterObjects, selectedIndex, selectedIds } = this.state;
        let newSelectedIds: number[] = [];

        if(!row.checked) {
            //if the action is an 'Add', (ie. previously not checked)
            newSelectedIds = selectedIds;
            newSelectedIds.push(row.id)
        }
        else {
            //if the action is a 'Remove'
            newSelectedIds = selectedIds.filter(n => n != row.id)
        }

        // Sets the correct 'checked' value as following:
        // this.state.filterObjects[selectedIndex].data[row.index].checked = !row.checked
        this.setState(({filterObjects, selectedIndex}) => ({
            selectedIds: newSelectedIds,
            filterObjects: [
                ...filterObjects.slice(0, selectedIndex),
                {
                    ...filterObjects[selectedIndex],
                    data: [
                        ...filterObjects[selectedIndex].data.slice(0, row.index),
                        { ...filterObjects[selectedIndex].data[row.index], checked: !row.checked },
                        ...filterObjects[selectedIndex].data.slice(row.index + 1)
                    ]
                },
                ...filterObjects.slice(selectedIndex + 1)
            ]
        }));
    }

    render() {
        const { } = this.props
        const { filterObjects, selectedIndex, isSaving, error, selectedPermissionType, selectedIds } = this.state
        const canSave = selectedIndex != -1 && selectedPermissionType != -1 && selectedIds.length > 0;

        const columns : {[s: string]: ColumnDescription<any, any>[]} = {
            school: [{
                    dataField: 'id',
                    text: 'ID',
                    hidden: true
                }, {
                    dataField: 'checked',
                    text: '',
                    sort: false,
                    //headerFormatter: (colDesc: ColumnDescription<any, any>) => (<div></div>),
                    headerStyle: { width: '3rem' },
                    formatter: (cell: boolean, row: any) => {
                        return (<div style={{ textAlign: 'center' }} >
                            <Checkbox checked={cell} /*onChange={(e: any) => this.changeUser(e, row)}*/ />
                        </div>);
                    }
                }, {
                    dataField: 'name',
                    //filter: textFilter(),
                    text: 'Namn',
                    sort: true
                }
            ],
            student: [{
                    dataField: 'id',
                    text: 'ID',
                    hidden: true
                }, {
                    dataField: 'checked',
                    text: '',
                    sort: false,
                    //headerFormatter: (colDesc: ColumnDescription<any, any>) => (<div></div>),
                    headerStyle: { width: '3rem' },
                    formatter: (cell: boolean, row: any) => {
                        return (<div style={{ textAlign: 'center' }} >
                            <Checkbox checked={cell} /*onChange={(e: any) => this.changeUser(e, row)}*/ />
                        </div>);
                    }
                }, {
                    dataField: 'firstName',
                    text: 'Förnamn',
                    sort: true
                }, {
                    dataField: 'lastName',
                    text: 'Efternamn',
                    sort: true
                }, {
                    dataField: 'socialSecurityNumber',
                    text: 'Personnummer',
                    sort: true
                }
            ],
            class: [{
                    dataField: 'id',
                    text: 'ID',
                    hidden: true
                }, {
                    dataField: 'checked',
                    text: '',
                    sort: false,
                    //headerFormatter: (colDesc: ColumnDescription<any, any>) => (<div></div>),
                    headerStyle: { width: '3rem' },
                    formatter: (cell: boolean, row: any) => {
                        return (<div style={{ textAlign: 'center' }} >
                            <Checkbox checked={cell} /*onChange={(e: any) => this.changeUser(e, row)}*/ />
                        </div>);
                    }
                }, {
                    dataField: 'name',
                    //filter: textFilter(),
                    text: 'Namn',
                    sort: true
                }
            ]
        }

        const selectedTypeObject = filterObjects[selectedIndex];

        return (<div className={"render-component-administration-editRolePermission"} style={{position:'relative'}}>
            <ErrorMessage hidden={error === null}>{error}</ErrorMessage>
            {isSaving ? 
                [
                    (<div style={{position:'absolute',backgroundColor:'rgba(255,255,255,0.7)',height:'100%',width:'100%'}}></div>),
                    (<div style={{
                            fontSize:'1.5rem',fontWeight:'bold', 
                            position:'absolute',height:'100%',
                            width:'100%',textAlign:'center'
                        }}
                    >
                        <Loading>
                            Sparar...
                        </Loading>
                    </div>)
                ]
            : null}
            <div>
                <Row>
                    <Col xs={12} md={6} >
                        <div style={{fontSize:'1.25rem', fontWeight:'bold', marginBottom:'0.5rem'}}>{"Rättighet:"}</div>
                        <select className="form-control" onChange={this.changeIndex}>
                            <option value={-1} disabled selected hidden>{"Välj rättighet..."}</option>
                            {filterObjects.map((obj, index) => {
                                return (
                                    <option value={index}>
                                        {obj.displayName}
                                    </option>
                                );
                            })}
                        </select>
                    </Col>
                    <Col xs={12} md={6} >
                        <div style={{fontSize:'1.25rem', fontWeight:'bold', marginBottom:'0.5rem'}}>{"Rättighetstyp:"}</div>
                        <select className="form-control" onChange={this.changePermissionType}>
                            <option value={-1} disabled selected hidden>{"Välj rättighetstyp..."}</option>
                            {PermissionTypes.options.map(({key, value}, index) => {
                                return (
                                    <option value={key}>
                                        {value}
                                    </option>
                                );
                            })}
                        </select>
                    </Col>
                </Row>
                <br/>
                <div style={{paddingBottom:'1rem'}} className={isSaving ? "blur" : ""}>
                    {selectedTypeObject != undefined ? 
                        <Table 
                            keyField="id" 
                            columns={columns[selectedTypeObject.fieldName]} 
                            data={selectedTypeObject.data} 
                            loading={false}
                            bsTableProps={{
                                rowEvents: { onClick: (e: React.MouseEvent<any>, row: any, rowIndex: number) => {
                                    this.changeId(row, rowIndex);
                                    //this.changeUser(e, row)
                                }},
                                rowStyle: (row: any, rowIndex: number) => {
                                    if(row.checked) {
                                        return {backgroundColor: '#86b74b', color: 'white', cursor: 'pointer'}
                                    }
                                    else { return {cursor: 'pointer'} }
                                },
                                defaultSorted: [{dataField:'checked', order: 'desc'}]
                            }}
                            pageSize={15}
                        />
                    : null}
                    <Button disabled={!canSave} onClick={this.createRolePermission} style={{fontSize:'1.25rem', float:'right'}}>{'Lägg till rättigheter'}</Button>
                </div>
            </div>
        </div>);
    }
}